export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvButton.vue?vue&type=template&id=bf5ba772&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvButton.vue?vue&type=template&id=bf5ba772&lang=pug&
// module id = 135
// module chunks = 0 1